import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

export interface ConfirmationDialogProps {
  title: string;
  content: string | React.ReactNode;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  handleConfirm: () => void;
  handleCancel: () => void;
  open: boolean;
  onClose: () => void;
  confirmButtonColor?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  loading?: boolean;
}

export default function ConfirmationDialog({
  title,
  content,
  confirmButtonLabel = 'Confirm',
  cancelButtonLabel = 'Cancel',
  handleConfirm,
  handleCancel,
  open,
  onClose,
  confirmButtonColor = 'primary',
  loading = false,
}: ConfirmationDialogProps) {
  const handleConfirmClick = () => {
    handleConfirm();
  };

  const handleCancelClick = () => {
    handleCancel();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {typeof content === 'string' ? <DialogContentText>{content}</DialogContentText> : content}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelClick} disabled={loading}>
          {cancelButtonLabel}
        </Button>
        <Button onClick={handleConfirmClick} color={confirmButtonColor} variant="contained" disabled={loading}>
          {confirmButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
